export default {
	buttons: require("./buttons.json"),
	messages: require("./messages.json"),
	labels: require("./labels.json"),
	validations: require("./validations.json")
};